import type { Client } from "features/container/types";

/**
 * This sorts so that the current client is always first and any client you follow
 * is the second one
 */
export function createSortByCurrentAndFollowingClient(
  currentClient: Client,
  followedClient?: Client,
): (a: Client, b: Client) => number {
  return (a: Client, b: Client) => {
    if (a.clientId === currentClient.clientId) {
      return -1;
    }

    if (b.clientId === currentClient.clientId) {
      return 1;
    }

    if (a.clientId === followedClient?.clientId) {
      return -1;
    }

    if (b.clientId === followedClient?.clientId) {
      return 1;
    }

    return 0;
  };
}
